// extracted by mini-css-extract-plugin
module.exports = {"roundButton":"RoundButton_roundButton__yFRfd","icon":"RoundButton_icon__vjXvi","withBorder":"RoundButton_withBorder__6FzJX","disabled":"RoundButton_disabled__G_D_f"};